import React from "react";

const AboutPage = () => {
    return (
        <div className="about-section">
  <h1>About Us</h1>
  <p className="about-mission">My mission is simple: to offer the highest quality powerwashing services with unparalleled customer satisfaction...</p>
  
  <div className="about-content">
    <h2>Why Choose Me?</h2>
    <ul>
      <li><strong>Experienced Professionals:</strong> I am an experienced technician who know the ins and outs of powerwashing...</li>
      <li><strong>Cutting-Edge Equipment:</strong> I use the latest in powerwashing technology to effectively remove dirt, grime, mold, and stains without damaging your surfaces...</li>
      <li><strong>Eco-Friendly Solutions:</strong> I care about the environment, which is why we use biodegradable, non-toxic cleaning solutions...</li>
      <li><strong>Customer Satisfaction Guaranteed:</strong> I take pride in my work, and your satisfaction is our top priority...</li>
    </ul>
    
    <h2>Our Services</h2>
    <ul>
      <li>Residential Powerwashing: Driveways, sidewalks, decks, patios, siding, and more.</li>
      <li>Commercial Powerwashing: Storefronts, parking lots, building exteriors, and more.</li>
      <li>Specialized Services: Roof cleaning, graffiti removal, and more.</li>
    </ul>

  </div>
</div>

    );
}

export default AboutPage;
